<ng-container *transloco="let t; read: 'notification'">
    <div class="absolute inset-0 flex flex-col min-w-0 overflow-hidden">
        <div class="flex flex-col sm:flex-row flex-0 sm:items-center sm:justify-between border-b dark:bg-transparent">
            <div class="flex flex-col gap-2 items-start md:items-center md:flex-row w-full">
                <div class="flex gap-2">
                    <button mat-icon-button title="Voltar" [routerLink]="'../'">
                        <mat-icon [svgIcon]="'heroicons_outline:arrow-narrow-left'"></mat-icon>
                    </button>
                    <div class="section-title">
                        {{ t("title") }}
                    </div>
                </div>
                <!-- filter selection -->
                <div class="w-full flex flex-1 items-center justify-center md:justify-end space-x-4">
                    <mat-form-field class="w-64">
                        <mat-label class="flex items-center">
                            <div>
                                {{ t("filter") }}
                            </div>
                            <mat-icon svgIcon="filter_alt"></mat-icon>
                        </mat-label>

                        <mat-select multiple [(ngModel)]="filter" (selectionChange)="onFilterChange($event.value)">
                            <mat-option *ngFor="let option of filterOptions" [value]="option.value">{{
                                option.label
                                }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
        </div>

        <div class="container-vertical-scroll" fuseScrollbar>
            <table mat-table [dataSource]="rows" class="w-full">
                <ng-container matColumnDef="emptyFooter">
                    <mat-footer-cell *matFooterCellDef></mat-footer-cell>
                </ng-container>

                <ng-container matColumnDef="icon">
                    <th *matHeaderCellDef class="pl-6 w-18 text-base font-semibold tracking-tight !text-[#4d4d4d]"></th>
                    <td mat-cell *matCellDef="let item">
                        <mat-icon>{{ item.icon }}</mat-icon>
                    </td>
                </ng-container>

                <ng-container matColumnDef="title">
                    <th *matHeaderCellDef class="text-base font-semibold tracking-tight !text-[#4d4d4d]">
                        {{ t("column.title") }}
                    </th>
                    <td mat-cell *matCellDef="let item">{{ item.title }}</td>
                </ng-container>

                <ng-container matColumnDef="subtitle">
                    <th *matHeaderCellDef class="text-base font-semibold tracking-tight !text-[#4d4d4d]">
                        {{ t("column.subtitle") }}
                    </th>
                    <td mat-cell *matCellDef="let item">{{ item.subtitle }}</td>
                </ng-container>

                <ng-container matColumnDef="id">
                    <th *matHeaderCellDef class="text-base font-semibold tracking-tight !text-[#4d4d4d]"></th>
                    <td mat-cell *matCellDef="let item">
                        <div class="flex flex-col gap-4 md:flex-row items-center justify-end md:pr-4">
                            <button *ngIf="!item.isRead" mat-icon-button color="primary"
                                (click)="markAsRead($event, item)" [matTooltip]="l('Marcar como lida')">
                                <mat-icon class="mat-icon material-icons">check</mat-icon>
                            </button>

                            <button mat-icon-button (click)="onDelete($event, item)" [matTooltip]="l('Excluir')">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </div>
                    </td>
                </ng-container>

                <tr class="border-b" mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr class="hover:bg-gray-50 cursor-pointer" mat-row *matRowDef="let row; columns: displayedColumns"
                    (click)="onSelect(row)"></tr>
            </table>
        </div>

        <div class="flex flex-col md:flex-row items-center justify-between border-t min-h-32 md:min-h-16">
            <mat-paginator [length]="totalItems" [pageSize]="pageSize" [hidePageSize]="true"
                (page)="onPageChanged($event)" class="bg-gray-50 dark:bg-transparent"
                [ngClass]="{ 'pointer-events-none': false }" [showFirstLastButtons]="true"></mat-paginator>
            <div class="flex flex-col md:flex-row gap-4">
                <button mat-stroked-button color="warn" (click)="deleteAll()">{{ l("Excluir todas") }}</button>

                <button mat-stroked-button color="primary" (click)="markAllAsRead()">
                    {{ l("Pages.Notifications.Action.MarkAllAsRead.Title") }}
                </button>
            </div>
        </div>
    </div>
</ng-container>